const MAILBOX_TYPES = {
    IN: 'in',
    OUT: 'out',
}

export default MAILBOX_TYPES
